// @flow
import React from 'react';
import { useFormikContext } from 'formik';

import { PrimaryButton } from '../presentational/buttons/PrimaryButton';
import {
  ADVANCED_SECURITY_CUSTOM_DISCOUNTS_JSON_BACKEND_NAME,
  ADVANCED_SECURITY_TIERS_BACKEND_NAME,
} from '../../constants';

import { getDefaultAdvancedSecurityTiers } from './utils';

export const AdvancedSecurityConfigureButton = ({ disabled }) => {
  const { setFieldValue } = useFormikContext();

  // Seed the default tiers into the form so the user can review/edit them. Nothing is persisted here —
  // the config is only written to the backend when the user clicks Save.
  const handleConfigure = () => {
    setFieldValue(ADVANCED_SECURITY_CUSTOM_DISCOUNTS_JSON_BACKEND_NAME, {
      [ADVANCED_SECURITY_TIERS_BACKEND_NAME]: getDefaultAdvancedSecurityTiers(),
    });
  };

  return (
    <PrimaryButton disabled={disabled} onClick={handleConfigure} text="Configure Custom Discount" />
  );
};
